import React from 'react';

export default function AlertIcon() {
  return (
    <svg
      width="100"
      height="100"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M99.3333 89.3333L56.6667 4C54 -1.33333 46.6667 -1.33333 44 4L0.66667 89.3333C-2 94 2 100 7.33334 100H92.6667C98 100 101.333 94 99.3333 89.3333ZM50 86.6667C44.6667 86.6667 40 82 40 76.6667C40 71.3333 44 66.6667 50 66.6667C56 66.6667 60 71.3333 60 76.6667C60 82.6667 55.3333 86.6667 50 86.6667ZM56.6667 60H43.3333L40 36.6667C40 34.6667 41.3333 33.3333 43.3333 33.3333H56.6667C58.6667 33.3333 60 34.6667 60 36.6667L56.6667 60Z"
        fill="#CE0404"
      />
    </svg>
  );
}
